import React from 'react'

interface IUserTableView {
  onEdit?: (id: string) => void;
}

const UsersTableView = ({ onEdit }: IUserTableView) => {
  return (
    <div>UsersTableView</div>
  )
}

export default UsersTableView